import observeStore from '../observeStore';
import { setMetadata } from '../actions/metadata.action';
import { formatLinkedTextToMetadata } from '../actions/navigation.prepare';

function onLinkedTextElementsUpdated (store) {
  return (linkedTextElements, state) => {
    const hasTextOverflow = state.metadata.text_overflow?.chains?.length > 0;
    const hasLinkedTextElements = linkedTextElements.length > 0;
    const shouldDispatchAction = !state.navigation.textOverflow.visible && (hasTextOverflow || hasLinkedTextElements);

    if (shouldDispatchAction) {
      store.dispatch(setMetadata({
        text_overflow: {
          chains: formatLinkedTextToMetadata(linkedTextElements)
        }
      }));
    }
  };
}

export function configureObserver (store) {
  observeStore(
    store,
    (state) => state.editor.linkedTextElements,
    onLinkedTextElementsUpdated(store)
  );
}
